import { render, staticRenderFns } from "./BusinessMatchHistory.vue?vue&type=template&id=4a8bb0ee&scoped=true"
import script from "./BusinessMatchHistory.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchHistory.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchHistory.vue?vue&type=style&index=0&id=4a8bb0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bb0ee",
  null
  
)

export default component.exports